import { request } from "./http";

export interface Alert {
  id: string;
  symbol: string;
  condition: "CROSS_ABOVE" | "CROSS_BELOW";
  side: "BID" | "ASK" | "MID";
  threshold: string;
  note: string | null;
  status: "ARMED" | "FIRED" | "CANCELED";
  fired_at: string | null;
  fired_price: string | null;
  created_at: string;
}

export interface AlertCreate {
  symbol: string;
  condition: "CROSS_ABOVE" | "CROSS_BELOW";
  side?: "BID" | "ASK" | "MID";
  threshold: string | number;
  note?: string;
}

export const alerts = {
  list: () => request<Alert[]>("/api/v1/alerts"),
  create: (body: AlertCreate) => request<Alert>("/api/v1/alerts", { body }),
  cancel: (id: string) => request<Alert>(`/api/v1/alerts/${id}/cancel`, { body: {} }),
  remove: (id: string) => request<void>(`/api/v1/alerts/${id}`, { method: "DELETE" }),
};
